import type { PayloadAction} from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@shared/hooks';

const initialState: { programId?: number } = {};

export const recommendProgramSlice = createSlice({
	name: 'programs/recommendProgram',
	initialState: initialState,
	reducers: {
		recommend: (state, action: PayloadAction<{ programId?: number }>) => {
			state.programId = action.payload.programId;
		},
	},
});

const { recommend } = recommendProgramSlice.actions;

const selectRecommendation = (state: RootState) => state.programFeatureReducers.recommend;

export const useRecommendModal = () => {
	const dispatch = useAppDispatch();

	const recommendation = useAppSelector(selectRecommendation);

	const toggleRecommendModal = (programId?: number) =>
		dispatch(recommend({ programId: programId }));
	return {
		recommendation,
		toggleRecommendModal,
	};
};
